import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { loadStripe } from '@stripe/stripe-js';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrl: './stripe-payment.component.css'
})
export class StripePaymentComponent implements OnInit, OnDestroy {
  load: boolean = false;
  error: string = '';
  plan: '';
  stripe: any;
  private checkout: any = null;

  constructor(private route: ActivatedRoute, private router: Router, private dataservice: CommonService, private ngZone: NgZone, private cdr: ChangeDetectorRef) {
    this.plan = this.route.snapshot.params.plan;
    this.stripe = loadStripe(this.dataservice.stripeKey);
  }

  ngOnInit(): void {
    this.initialize();
  }

  cancel(): void {
    this.router.navigate(['panel/pricing']);
  }

  ngOnDestroy(): void {
    if (this.checkout) {
      this.checkout.destroy();
      this.checkout = null;
    }
  }

  async initialize() {
    try {
      const fetchClientSecret = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", 'Bearer ' + JSON.parse(localStorage.getItem('currentUser')));
        const response = await fetch(this.dataservice.siteUrl + "/api/plan-payment", {
          method: "POST",
          body: JSON.stringify({ plan: this.plan }),
          headers: myHeaders,
        });
        const responseData = await response.json();

        if (!response.ok || !responseData.success) {
          const msg = responseData.error ?? responseData.error_message ?? 'Failed to load payment form.';
          this.ngZone.run(() => { this.error = msg; this.load = true; });
          throw new Error(msg);
        }

        return responseData.success;
      };

      this.checkout = await (await this.stripe).initEmbeddedCheckout({ fetchClientSecret });
      this.ngZone.run(() => { this.load = true; this.cdr.detectChanges(); });
      this.checkout.mount('#checkout');

    } catch (e: any) {
      this.ngZone.run(() => {
        this.load = true;
        if (!this.error) {
          this.error = e?.message ?? 'Something went wrong loading the payment form.';
        }
      });
    }
  }
}
